module.exports = __webpack_public_path__ + "img/2_77.b5d426d3.png";